<template>
    <div class="w-100 h-100 text-center">
        <h1 class="display-2">
            {{title}}
        </h1>

        <div class="tw-h-16 tw-red-100"></div>
        
        <div>
            <b-button class="mx-2" @click="thick()">&lt; 100 (Thick Film Counting)</b-button>
            <b-button class="mx-2" @click="thin()">&gt; 100 (Thin Film Counting)</b-button>
        </div>
    </div>
</template>

<script>
    // import {
    //     HTTP
    // } from '@/utilities/http-common';
    // import HandleErrors from '@/utilities/handle-errors';

    // import BaseTemplate from '@/layouts/BaseTemplate.vue'
    import {
        mapState, mapActions
    } from 'vuex';
    import DashboardBaseTemplate from '@/layouts/DashboardBaseTemplate.vue'

    export default {
        mixins: [
            // BaseTemplate,
            DashboardBaseTemplate
        ],
        components: {

        },
        props: {
            prop: {
              type: String,
              required: false,
              default: "Sample prop"
            }
        },
        data: function () {
            return {
                title: 'Thick Or Thin Film Counting'
            }
        },
        computed: {
            ...mapState('sample', ['sample']),
            ...mapState('smicroscopy', ['entries'])
        },
        created: function () {

        },
        mounted: function () {

        },
        methods: {
            ...mapActions('smicroscopy', ['updateThickOrThin']),
            thick: function() {
                this.updateThickOrThin({index: this.$route.params.index, thickOrThin: 'thick'});
                this.$router.push({name: 'thick-film-counting'});
            },
            thin: function() {
                this.updateThickOrThin({index: this.$route.params.index, thickOrThin: 'thin'});
                this.$router.push({name: 'thin-film-counting'});
            },
            get: function () {
                // HTTP.get('/').then((response) => {
                //     let something = response.data;
                // }).catch((error) => {
                //     HandleErrors.HandleErrors(error);
                // });
            },
            find: function () {

            },
            patch: function () {

            },
            delete: function () {

            }
        }
    }
</script>
